﻿export interface MarkerData {
  latitude: number;
  longitude: number;
  title?: string;
  content?: string;
}

export interface MapData {
  elementSelector: string;
  mapOptions: any;
  markers: MarkerData[];
}

export async function initMap(configUrl = '/maps.json'): Promise<void> {
  try {
    const response = await fetch(configUrl);
    if (!response.ok) throw new Error(`Failed to load map config: ${response.status} ${response.statusText}`);

    const mapData = (await response.json()) as MapData;
    const element = document.querySelector(mapData.elementSelector) as HTMLElement | null;
    if (!element) {
      console.error(`Element not found for selector: ${mapData.elementSelector}`);
      return;
    }

    const googleGlobal = (window as any).google;
    if (!googleGlobal || !googleGlobal.maps) {
      console.error('Google Maps API is not loaded. Make sure the script is included.');
      return;
    }

    const map = new googleGlobal.maps.Map(element, mapData.mapOptions);

    const _setMarker = function (marker: MarkerData) {
      const markerPosition = new googleGlobal.maps.LatLng(marker.latitude, marker.longitude);
      map.setCenter(markerPosition);

      const markerIcon = new googleGlobal.maps.Marker({
        position: markerPosition,
        map: map,
        title: marker.title,
      });

      if (marker.content) {
        const infoWindow = new googleGlobal.maps.InfoWindow({
          content: marker.content,
        });

        markerIcon.addListener('click', () => {
          infoWindow.open(map, markerIcon);
        });
      }

      return markerIcon;
    };

    if (!Array.isArray(mapData.markers) || mapData.markers.length === 0) {
      console.warn('No markers provided in map data.');
      return;
    }

    if (mapData.markers.length > 1) {
      const bounds = new googleGlobal.maps.LatLngBounds();
      for (let i = 0; i < mapData.markers.length; i++) {
        const markerIcon = _setMarker(mapData.markers[i]);
        bounds.extend(markerIcon.getPosition());
      }

      map.fitBounds(bounds);
    } else {
      _setMarker(mapData.markers[0]);
    }
  } catch (err) {
    console.error('Error initializing map:', err);
  }
}
